// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aYGK","name":"styles_name__16nr1","phone":"styles_phone__2G5ZA"};